export default "__VITE_ASSET__5023f2f8__"